import { createFileRoute, Outlet, redirect, useLocation } from "@tanstack/react-router";
import { me } from "@/lib/api/auth.functions";
import { AdminSidebar } from "@/components/admin/AdminSidebar";

export const Route = createFileRoute("/admin")({
  beforeLoad: async ({ location }) => {
    if (location.pathname === "/admin/login") return;
    const user = await me();
    if (!user) throw redirect({ to: "/admin/login" });
    return { adminUser: user };
  },
  head: () => ({
    meta: [{ name: "robots", content: "noindex, nofollow" }],
  }),
  component: AdminLayout,
});

function AdminLayout() {
  const location = useLocation();
  const { adminUser } = Route.useRouteContext();

  if (location.pathname === "/admin/login") {
    return <Outlet />;
  }

  if (!adminUser) return null;

  return (
    <div className="flex min-h-screen bg-background">
      <AdminSidebar user={adminUser} />
      <main className="flex-1 overflow-auto p-6 md:p-8">
        <Outlet />
      </main>
    </div>
  );
}
